import { Controller } from '@hotwired/stimulus';
import { useEventListener } from 'stimulus-library/dist';

export default class extends Controller {
  static targets = ['template', 'picker', 'pickerInput', 'output'];

  connect() {
    useEventListener(this, this.pickerInputTarget, 'change', this.pickTemplate);
  }

  pickTemplate(event) {
    console.log('pickTemplate', event);
    const template = this.templateTargets.find((t) => {
      console.log('t.dataset.template', t.dataset.template, event.target.value);
      return t.dataset.template === event.target.value;
    });
    if (template) {
      this.pickerTarget.classList.add('hidden');
      this.outputTarget.innerHTML = template.innerHTML;
    } else {
      console.log('no template found');
    }
  }
}
